import { useMutation } from 'react-query';

import { mapToContract as mutationFn } from 'api/endPoints/mapToContract';

import { ICreateMapping } from 'components/pages/PhasePerformanceManagePage/components/Manage/Manage.types';

export const useMutationCreateMapping = () => {
    return useMutation<unknown, QueryError, ICreateMapping>((params) => mutationFn(params));
};
